import { decodeQuery } from "@zedoc/url";

const query = decodeQuery(window.location.search);

const isDebug = process.env.NODE_ENV !== "production" || !!query.debug;

export default isDebug;
